import React, { useState, useEffect } from "react";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { useController } from "react-hook-form";

import RankingItem from "./rankingItem.component";
import { StyledWrapper } from "./ranking.style";

const Ranking = ({
  control,
  options,
  name,
  required,
  error,
  readOnly,
  callback = undefined,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const { field } = useController({
    name,
    control,
    rules: { required: { value: required, message: "This field is required" } },
  });
  const [items, setItems] = useState(() => {
    if (field.value) {
      return field.value.split(",").map((option) => option.trim());
    }
    return [...options];
  });

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  useEffect(() => {
    if (callback) {
      callback(items);
    }
  }, [items, callback]);

  return (
    <StyledWrapper>
      <input
        type="hidden"
        value={items?.join(",")}
        onChange={field.onChange}
        onBlur={field.onBlur}
        name={field.name}
        ref={field.ref}
      />
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <SortableContext
          items={items}
          strategy={verticalListSortingStrategy}
          disabled={readOnly}
        >
          {items.map((option) => (
            <RankingItem key={option} option={option} readOnly={readOnly} />
          ))}
        </SortableContext>
      </DndContext>
      <span className="error">{error?.message || ""}</span>
    </StyledWrapper>
  );
};

export default Ranking;
